import _objectSpread from "/root/workspace/ubq-h5_test/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.object.keys.js";
import router from '@/router';
import store from '@/store';
import { registerMicroApps } from 'qiankun';
import { UMENGEventId } from './utils/umeng';
import Package from '../package.json';
import { ProdStaticUrl, ProductionUrl } from '@/utils/request';
import bridgeApp from '@/utils/app';
import Utils from '@/utils/utils';
var VUE_APP_ENV = process.env.VUE_APP_ENV;

// 开发环境
var development = {
  brand: '//dev-brand-h5.ubanquan.cn/' // localhost:3000 //dev-brand-h5.ubanquan.cn/
};

// 测试环境
var test = {
  brand: '//test-brand-h5.ubanquan.cn/'
};

// 预发布
var realpre = {
  brand: '//realpre-brand-h5.ubanquan.cn/'
};

// 生成环境
var production = {
  brand: '//brand-h5.ubanquan.cn/'
};

// 生成入口地址
var entryType = {
  development: development,
  realpre: realpre,
  test: test,
  production: production
}[VUE_APP_ENV];

// 生成子应用入口
export var microAppList = Object.keys(entryType).map(function (name) {
  return {
    name: name,
    // 应用名称
    entry: entryType[name],
    // 入口 || 访问地址
    container: '#microApp',
    // 子应用所在容器(div)
    activeRule: "/".concat(name),
    // 子应用触发规则（路径）
    props: {
      router: router,
      store: store,
      UMENGEventId: UMENGEventId,
      version: Package.version,
      api: {
        ProductionUrl: ProductionUrl,
        ProdStaticUrl: ProdStaticUrl
      },
      bridgeApp: _objectSpread(_objectSpread({}, bridgeApp), {}, {
        appInfo: Utils.appInfo
      })
    } // 额外传递给子应用的参数
  };
});

// 注册子应用
registerMicroApps(microAppList);
// 开启服务
// start()